import { css } from '@emotion/react';
import type { HTMLAttributes } from 'react';
import {
  LottieAnimationComponent, type LottieAnimationProps,
} from '~/_shared/baseComponents/lottieAnimation';

const hiddenStyle = css({ display: 'none' });

type AnimationPreloadProps = {
  animationsToPreload: readonly LottieAnimationProps[];
};

export const AnimationPreloadComponent = ({
  animationsToPreload,
  ...divProps
}: AnimationPreloadProps & HTMLAttributes<HTMLDivElement>) => {

  /**
   * We need to preload animations for the proximity export status items.
   * Safari will not load chunks when no user action was performed.
   */
  return (
    <div css={hiddenStyle} {...divProps}>
      {animationsToPreload.map(animationProps => {
        return (
          <LottieAnimationComponent
            key={animationProps.type}
            {...animationProps}
          />
        );
      })}
    </div>
  );
};
